import { z } from "zod"

export const CustomerDeviceSchema = z.object({
  id: z.number(),
  apns_token: z.string(),
  is_active: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
})

export type CustomerDevice = z.infer<typeof CustomerDeviceSchema>
